import { render, staticRenderFns } from "./ManageSeminarParticipants.vue?vue&type=template&id=534ee477&scoped=true&"
import script from "./ManageSeminarParticipants.vue?vue&type=script&lang=js&"
export * from "./ManageSeminarParticipants.vue?vue&type=script&lang=js&"
import style0 from "./ManageSeminarParticipants.vue?vue&type=style&index=0&id=534ee477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ee477",
  null
  
)

export default component.exports